
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um-okkur",
      function () {
        return require("private-next-pages/um-okkur.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um-okkur"])
      });
    }
  